import * as React from "react";
import { inject, observer } from "mobx-react";
import { RouterStore } from "mobx-react-router";
import AccountService from "../../service/AccountService";
import { styled } from "@mui/material/styles";
import firebase from "firebase/compat/app";
import "antd/dist/antd.css";
import {
  Form,
  Input,
  TagPicker,
  InputGroup,
  RadioGroup,
  Radio,
  SelectPicker,
  DatePicker,
  Checkbox as CustomCheckBox,
  Whisper,
  Tooltip,
} from "rsuite";

import {
  Paper,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Snackbar,
  CircularProgress,
  Checkbox,
  TableContainer,
  TableHead,
  TableBody,
  Table,
  TableCell,
  TableRow,
  TableSortLabel,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Box,
} from "@mui/material";
import LogoutButton from "../common/LogoutButton";
import BackIcon from "@mui/icons-material/ArrowBack";
import autobind from "autobind-decorator";
import AddIcon from "@mui/icons-material/Add";
import { observable } from "mobx";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import Pagination from "@mui/material/Pagination";
import ContactService, {
  ContactData,
  ContactResult,
} from "../../service/ContactService";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { v4 as uuid } from "uuid";
import { checkEmpty } from "../../util/util";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import FileService from "../../service/FileService";
import ClearIcon from "@mui/icons-material/Clear";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
import moment from "moment";
import { withStyles } from "@mui/styles";
import htmlToDraft from "html-to-draftjs";
import { ContentState, convertFromHTML, convertToRaw } from "draft-js";
import { CustomContactForm } from "./components/ContactForm";
import HelpOutlineIcon from "@rsuite/icons/HelpOutline";
import { CustomTooltip } from "../file-list/FileListPage";

const rowsPerPage = 15;

const CustomButton = styled(Button)({
  height: "40px",
  borderRadius: "20px",
  backgroundColor: "#6c757d",
  padding: "6px 20px",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#6c757d",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#6c757d",
  },
});

const CustomLocation = styled("div")({
  backgroundColor: "#83716a",
  color: "#fff",
  width: "fit-content",
  padding: "6px 16px",
  borderRadius: "16px",
  margin: "5px",
});

const Alert = (props: AlertProps) => {
  return (
    <MuiAlert
      elevation={6}
      variant="filled"
      {...props}
      style={{ width: "100%" }}
    />
  );
};

const CustomHelperTextError = () => (
  <div
    style={{
      color: "red",
      display: "flex",
      alignItems: "center",
      margin: "4px 0",
    }}
  >
    <ErrorOutlineOutlinedIcon style={{ marginRight: "4px" }} />
    <span>This field is required</span>
  </div>
);

const SubmitButton = styled(Button)((props) => ({
  margin: props.theme.spacing(3, 0, 2),
  minWidth: "120px",
}));

const CustomIconButton = styled(IconButton)({
  backgroundColor: "#4994fd",
  color: "#fff",
  margin: "0 0.5rem",
  height: "40px",
  width: "40px",
  "&:hover": {
    backgroundColor: "#4994fd",
    color: "#fff",
  },
});

export const StyledTableCell = withStyles({
  head: {
    backgroundColor: "rgb(196,196,196,.15)",
  },
})(TableCell);

export const StyledTableRow = withStyles({
  root: {
    borderBottomStyle: "solid",
    borderBottomColor: "rgb(0,0,0,0.18)",
    borderBottomWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: "rgb(0,0,0,0.18)",
    borderTopWidth: "1px",
  },
})(TableRow);

type SnackbarMessageType = "success" | "error" | "info" | "warning";

type Sort = "desc" | "asc";

export type OrderType = "name" | "email" | "phone" | "location" | "createdAt";

export type ContactState =
  | "NORMAL"
  | "LOADING"
  | ContactResult
  | "EMPTY_SELECTED_CONTACTS"
  | "SEND_EMAIL_SMS"
  | "EMPTY_SELECTED_TEMPLATE";

export type ActionType = "Add" | "Update" | "Delete";

type ContactPageProps = {
  routing?: RouterStore;
  account?: AccountService;
  files?: FileService;
};

type ContactPageState = {
  searchText: string;
  checkedAll: boolean;
  pageNum: number;
  sendCategory: string;
  ratioSMSTemplate: string;
};

@inject("routing")
@inject("account")
@inject("files")
@observer
export default class ContactPage extends React.Component<
  ContactPageProps,
  ContactPageState
> {
  state = {
    searchText: "",
    checkedAll: false,
    pageNum: 1,
    sendCategory: "Email",
    ratioSMSTemplate: "exist",
  };

  @observable
  private _contactService: ContactService = new ContactService(
    this.props.account
  );

  @observable
  private _fsContacts = Array<ContactData | any>();

  @observable
  private _contacts = Array<ContactData | any>();

  @observable
  private _selectedContacts = Array<any>();

  @observable
  private _checkedAll: boolean = false;

  @observable
  private _order: Sort = "desc";

  @observable
  private _orderBy: OrderType = "createdAt";

  @observable
  private _showContactModal = false;

  @observable
  private _showSendModal = false;

  @observable
  private _showDeleteModal = false;

  @observable
  private _showLocationsModal = false;

  @observable
  private _name = "";

  @observable
  private _email = "";

  @observable
  private _phone = "";

  @observable
  private _locations: Array<any> = [];

  @observable
  private _workflows = [];

  @observable
  private _fsTemplates = [];

  @observable _selectedLocations = [];

  @observable _selectedContact: ContactData = null;

  @observable _selectedContactId: string = "";

  @observable
  private _status: ContactState = "NORMAL";

  @observable
  private _checkEmptyForm: boolean = false;

  @observable
  private _showSnackbar: boolean = false;

  @observable
  private _actionType: ActionType = "Add";

  @observable
  private _locationActionType: "Add" | "Remove" = null;

  @observable
  searchText = "";

  @observable
  emailText = "";

  @observable
  smsText = "";

  @observable
  selectedLocation = "";

  @observable
  selectedWorkflow = "";

  @observable
  selectedTemplate = null;

  @observable
  messingLocations: Array<any> = [];

  @observable
  locationsToAction: Array<any> = [];

  @observable
  sendLater: boolean = false;

  @observable
  sendAt: Date = null;

  @observable
  isLoading: boolean = false;

  @observable
  dataLoading: boolean = true;

  @observable
  profilPicture: string = "";

  @observable
  includeProfilImg: boolean = false;

  @autobind
  goBack() {
    this.props.account.goBack();
  }

  getEmailErrorMessage(): string {
    if (this._status == "INVALID_EMAIL") {
      return "Email is invalid.";
    }

    return null;
  }
  getNameErrorMessage(): string {
    if (this._status == "INVALID_EMAIL") {
      return "Email is invalid.";
    }

    return null;
  }

  pageChangeHandler = (event: React.ChangeEvent<unknown>, value: number) => {
    event.preventDefault();
    window.scrollTo(0, 0);
    this.setState({ ...this.state, pageNum: value });
  };

  @autobind
  handleNameChange(val: any) {
    this._name = val;
  }

  @autobind
  handleEmailChange(val: any) {
    this._email = val;
  }

  @autobind
  handlePhoneChange(val: any) {
    this._phone = val;
  }

  @autobind
  handleLocationsChange(val: any) {
    this._selectedLocations = val;
  }

  @autobind
  listToDataPicker(
    data: Array<any>,
    key: string,
    labelName: string,
    labelValue: string
  ): Array<any> {
    if (data?.length === 0) {
      return [];
    }
    return data.map((item) => {
      return {
        key: item[`${key}`],
        label: item[`${labelName}`],
        value: labelValue ? item[`${labelValue}`] : item,
      };
    });
  }

  @autobind
  async getLocations() {
    const locations = [];
    this.props.account.clinics.forEach(({ clinicId, name }) =>
      locations.push({ locationId: clinicId, locationName: name })
    );
    this._locations = locations;
  }

  @autobind
  async getContacts() {
    const result = await this._contactService.fetchAllContacts();
    if (result === "GET_SUCCESS") {
      this._fsContacts = this._contactService.allContacts;
      this._contacts = this._contactService.allContacts;
    }
  }

  @autobind
  async getWorkflows(location: string) {
    this._workflows = await this.props.files.getWorkflows(location);
  }

  @autobind
  async getTemplates() {
    const result = await this._contactService.getTemplates();
    if (result === "GET_SUCCESS") {
      this._fsTemplates = this._contactService.allFsTemplates;
    }
  }

  // @autobind
  // async getLocationsToAdd() {
  //   const selectedLocations = [];
  //   this._selectedContacts.forEach(({ locations }) =>
  //     selectedLocations.push(...locations)
  //   );
  //   const selectedLocationsIds = selectedLocations.map(
  //     (location) => location.locationId
  //   );
  //   const filteredLocations = this._locations.filter(
  //     ({ locationId }) => !selectedLocationsIds.includes(locationId)
  //   );

  //   this.messingLocations = [...filteredLocations];
  // }

  // @autobind
  // async getLocationsToRemove() {
  //   const selectedLocations = [];
  //   this._selectedContacts.forEach(({ locations }) =>
  //     selectedLocations.push(...locations)
  //   );
  //   const selectedLocationsIds = selectedLocations.map(
  //     (location) => location.locationId
  //   );
  //   const filteredLocations = selectedLocations.filter(
  //     ({ locationId }, idx) =>
  //       !selectedLocationsIds.includes(locationId, idx + 1)
  //   );

  //   this.messingLocations = [...filteredLocations];
  // }

  @autobind
  resetValues() {
    this._name = "";
    this._email = "";
    this._phone = "";
    this._selectedLocations = [];
    this._selectedContacts = [];
    this._selectedContact = null;
    this.selectedLocation = null;
    this.selectedWorkflow = null;
    this.selectedTemplate = null;
    this.locationsToAction = [];
    this.isLoading = false;
  }

  @autobind
  searchedContacts() {
    const newContacts = this._fsContacts.filter((contact) =>
      contact.name.includes(this.state.searchText)
    );
    return newContacts;
  }

  addContactHandler = async (event: any) => {
    event.preventDefault();
    let contactData: ContactData = {
      contactId: uuid(),
      name: this._name.trim(),
      email: this._email.trim(),
      phone: `+${this._phone.trim()}`,
      locations: this._selectedLocations,
      createdAt: new Date().toString(),
    };
    const state = checkEmpty(contactData);
    if (state) {
      this._checkEmptyForm = true;
    } else {
      const contactResult = await this._contactService.addContact(contactData);
      if (contactResult === "CONTACT_IS_EXIST") {
        this._status = "CONTACT_IS_EXIST";
        this._showSnackbar = true;
        this.isLoading = false;
      } else if (contactResult === "ADD_SUCCESS") {
        this._status = "ADD_SUCCESS";
        this._showContactModal = false;
        this._showSnackbar = true;
        this.resetValues();
        this.getContacts();
        this._selectedContacts = [];
      } else {
        this._status = "UNKNOWN_ERROR";
        this._showContactModal = false;
        this._showSnackbar = true;
        this.isLoading = false;
      }
    }
  };

  updateContactHandler = async (event: any) => {
    event.preventDefault();
    const contactData: ContactData = {
      ...this._selectedContact,
      name: this._name.trim(),
      email: this._email.trim(),
      phone: `+${this._phone.trim()}`,
      locations: this._selectedLocations,
    };
    const state = checkEmpty(contactData);
    if (state) {
      this._checkEmptyForm = true;
    } else {
      const contactResult = await this._contactService.updateContact(
        contactData,
        this._selectedContactId
      );

      if (contactResult === "CONTACT_IS_EXIST") {
        this._status = "CONTACT_IS_EXIST";
        this._showSnackbar = true;
        this.isLoading = false;
      } else if (contactResult === "UPDATE_SUCCESS") {
        this._status = "UPDATE_SUCCESS";
        this._showContactModal = false;
        this._showSnackbar = true;
        this.resetValues();
        this.getContacts();
        this._selectedContacts = [];
      } else {
        this._status = "UNKNOWN_ERROR";
        this._showContactModal = false;
        this._showSnackbar = true;
      }
    }
  };

  deleteContactHandler = async (event: any) => {
    event.preventDefault();
    const result = await this._contactService.deleteContact(
      this._selectedContactId
    );
    this._showContactModal = false;
    if (result === "DELETE_SUCCESS") {
      this._status = "DELETE_SUCCESS";
      this._showSnackbar = true;
      this.resetValues();
      this.getContacts();
      this._selectedContacts = [];
    } else {
      this._status = "UNKNOWN_ERROR";
      this._showContactModal = false;
      this._showSnackbar = true;
    }
  };

  deleteContactsHandler = async (event: any) => {
    event.preventDefault();
    const result = await this._contactService.deleteContacts(
      this._selectedContacts
    );
    this._showDeleteModal = false;
    if (result === "DELETE_CONTACTS_SUCCESS") {
      this._status = "DELETE_CONTACTS_SUCCESS";
      this._showSnackbar = true;
      this.resetValues();
      this.getContacts();
      this._selectedContacts = [];
    } else {
      this._status = "UNKNOWN_ERROR";
      this._showDeleteModal = false;
      this._showSnackbar = true;
    }
  };

  @autobind
  async getContactInfo(contactId: string) {
    const result = await this._contactService.getContact(contactId);
    if (result === "GET_SUCCESS") {
      this._selectedContact = this._contactService.selectedContact;
      this._name = this._selectedContact.name;
      this._email = this._selectedContact.email;
      this._phone = this._selectedContact.phone.slice(1);
      this._selectedLocations = this._selectedContact.locations;
    }
  }

  @autobind
  async sendHandler(ev: any) {
    ev.preventDefault();
    const funcs = firebase.functions();
    const sendEmailFunc = funcs.httpsCallable("sendEmailHandler");
    const sendSmsFunc = funcs.httpsCallable("sendSMSHandler");
    let promises = this._selectedContacts.map(async (contact) => {
      const { name, email, phone } = contact;
      if (this.state.sendCategory === "Email") {
        const { content } =
          this._fsTemplates.filter(
            (temp) => temp.templateId === this.selectedTemplate
          )?.[0] ?? {};
        const survey_url =
          this.selectedWorkflow &&
          (await this.props.files.getShortenUrl(this.selectedWorkflow));
        const { locationName: location_name } =
          this._locations.filter(
            (loc) => loc.locationId === this.selectedLocation
          )?.[0] ?? {};
        const emailData = {
          templateId: this.selectedTemplate,
          email,
          htmlMessageText: this.renderEmailPreview(content),
          sendAt: this.sendAt ? moment(this.sendAt).unix() : null,
          dynamicData: {
            name,
            phone,
            email,
            location_name,
            survey_url,
          },
        };
        return sendEmailFunc(emailData);
      } else {
        const content =
          this.state.ratioSMSTemplate === "exist"
            ? this._fsTemplates.filter(
                (temp) => temp.templateId === this.selectedTemplate
              )?.[0]?.content
            : this.smsText;
        const smsData = {
          phone,
          messageText: content,
          profilImg: this.profilPicture,
          includeProfilImg: this.includeProfilImg,
          sendAt: this.sendAt ? moment(this.sendAt).toISOString() : null,
        };
        return sendSmsFunc(smsData);
      }
    });
    if (this._selectedContacts.length > 0) {
      if (this.selectedTemplate) {
        let result = await Promise.all(promises);
        this._status = "SEND_EMAIL_SMS";
        this._showSendModal = false;
        this._showSnackbar = true;
        setTimeout(() => {
          this.isLoading = false;
          this.resetValues();
        });
      } else {
        this._status = "EMPTY_SELECTED_TEMPLATE";
        this._showSnackbar = true;
        this.isLoading = false;
      }
    } else {
      this._status = "EMPTY_SELECTED_CONTACTS";
      this._showSnackbar = true;
      this.isLoading = false;
    }
  }

  async componentDidMount() {
    await this.getLocations();
    await this.getContacts();
    await this.getTemplates();
    if (this.props.account.userData.displayPic) {
      this.profilPicture = this.props.account.userData.displayPic;
    }
    this.dataLoading = false;
  }

  async componentDidUpdate(
    _: Readonly<ContactPageProps>,
    prevState: Readonly<{ searchText: string }>
  ) {
    if (prevState.searchText != this.state.searchText) {
      this._contacts = this.searchedContacts();
    }
  }

  @autobind
  checkContactHandler(event: any, contact: ContactData) {
    const { contactId } = contact;
    if (event.target.checked) {
      this._selectedContacts = [...this._selectedContacts, contact];
    } else {
      this._selectedContacts = this._selectedContacts.filter(
        (contact) => contact.contactId !== contactId
      );
    }
  }

  @autobind
  checkAllContactHandler(event: any) {
    if (event.target.checked) {
      this._selectedContacts = [...this.searchedContacts()];
    } else {
      this._selectedContacts = [];
    }
  }

  @autobind
  isContactChecked(contactId: string): boolean {
    const contactsResult = this._selectedContacts.filter(
      (contact) => contact.contactId === contactId
    );
    if (contactsResult?.length > 0) return true;
    else return false;
  }

  @autobind
  async updateWorkflows(location: string) {
    if (location === "") {
      this._workflows = [];
    }
  }

  @autobind
  handleSendCategoryChange(name: string, value: string) {
    this.setState({ ...this.state, [name]: value });
  }

  @autobind
  async handleLocationChange(location: string) {
    this.selectedLocation = location;
    await this.getWorkflows(location);
  }

  @autobind
  async addLocationsHandler(event: any) {
    event.preventDefault();
    const result = await this._contactService.addLocationsToContacts(
      this.locationsToAction,
      this._selectedContacts
    );
    this._showLocationsModal = false;
    if (result === "ADD_LOCATIONS_SUCCESS") {
      this._status = "ADD_LOCATIONS_SUCCESS";
      this._showSnackbar = true;
      this.resetValues();
      this.getContacts();
      this._selectedContacts = [];
      this.messingLocations = [];
    } else {
      this._status = "UNKNOWN_ERROR";
      this._showLocationsModal = false;
      this._showSnackbar = true;
    }
  }
  @autobind
  async removeLocationsHandler(event: any) {
    event.preventDefault();
    const result = await this._contactService.removeLocationsFromContacts(
      this.locationsToAction,
      this._selectedContacts
    );
    this._showLocationsModal = false;
    if (result === "REMOVE_LOCATIONS_SUCCESS") {
      this._status = "REMOVE_LOCATIONS_SUCCESS";
      this._showSnackbar = true;
      this.resetValues();
      this.getContacts();
      this._selectedContacts = [];
    } else {
      this._status = "UNKNOWN_ERROR";
      this._showLocationsModal = false;
      this._showSnackbar = true;
    }
  }

  renderEmailPreview(content: any) {
    return `<div
    style="
    background-color: #e1e1e1;
    border-radius: 6px;
    align-items: center;
    padding: 2rem 1rem;
    margin: 1rem auto;"
  >
  ${
    this.profilPicture &&
    `<div style=" width: 75%; background-color: white; border-radius: 6px; padding: 2rem 1rem; margin: 1rem auto;"> <img src=${this.profilPicture} alt="" style="width: 100px; height: 100px; border-radius: 50%;display:block; margin:1rem auto"/></div>`
  }
  
    <div
      style="
        width: 75%;
        background-color: white;
        border-radius: 6px;
        padding: 2rem 1rem;
        margin: 1rem auto;
      "
    >
      ${content}
    </div>
    <div>{{name}}</div>
    <div>{{email}}</div>
    <div>{{location}}</div>
    <div>{{url}}</div>
  </div>
  `;
  }

  renderSMSMessage(content: any) {
    const blocksFromHtml = convertFromHTML(content);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    const blocks = convertToRaw(contentState).blocks;
    const value = blocks
      .map((block) => (!block.text.trim() && "\n") || block.text)
      .join("\n");
    return value;
  }

  renderNavBar() {
    return (
      <AppBar position="static">
        <Toolbar variant="dense">
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={this.goBack}
          >
            <BackIcon />
          </IconButton>
          <Typography variant="h6" style={{ flexGrow: 1, color: "inherit" }}>
            Contact
          </Typography>
          <LogoutButton />
        </Toolbar>
      </AppBar>
    );
  }

  renderSearchBar() {
    return (
      <Paper style={{ margin: "1rem" }}>
        <div
          style={{
            display: "flex",
            columnGap: "40px",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1.5rem 2.5rem",
          }}
        >
          <InputGroup style={{ width: "400px" }}>
            <Input
              placeholder="Search Contacts"
              onChange={(val: any) =>
                this.setState({ ...this.state, searchText: val })
              }
              value={this.state.searchText}
            />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              this._showContactModal = true;
              this._actionType = "Add";
            }}
            size="medium"
            style={{ height: "40px" }}
          >
            <AddIcon style={{ marginRight: "0.6rem" }} />
            add contact
          </Button>
        </div>
      </Paper>
    );
  }

  renderGlobalAction() {
    return (
      <Paper style={{ margin: "1rem" }}>
        <div
          style={{
            display: "flex",
            columnGap: "40px",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1.5rem 2.5rem",
          }}
        >
          <Checkbox
            checked={this._selectedContacts?.length > 0}
            onChange={(e) => this.checkAllContactHandler(e)}
            inputProps={{ "aria-label": "controlled" }}
            style={{ color: "#6c757d" }}
          />
          <CustomButton
            variant="contained"
            onClick={() => {
              this._showSendModal = true;
            }}
            size="medium"
          >
            <SendIcon style={{ marginRight: "0.6rem" }} />
            send
          </CustomButton>
          <CustomButton
            variant="contained"
            onClick={() => {
              this._showLocationsModal = true;
              this._locationActionType = "Add";
              // this.getLocationsToAdd();
            }}
            size="medium"
          >
            <BookmarkAddIcon style={{ marginRight: "0.6rem" }} />
            Add Locations
          </CustomButton>
          <CustomButton
            variant="contained"
            onClick={() => {
              this._showLocationsModal = true;
              this._locationActionType = "Remove";
              // this.getLocationsToRemove();
            }}
            size="medium"
          >
            <BookmarkRemoveIcon style={{ marginRight: "0.6rem" }} />
            Remove Locations
          </CustomButton>
          <CustomButton
            variant="contained"
            onClick={() => {
              this._showDeleteModal = true;
            }}
            size="medium"
          >
            <DeleteIcon style={{ marginRight: "0.6rem" }} />
            Delete
          </CustomButton>
        </div>
      </Paper>
    );
  }

  renderContactsTable() {
    return (
      <Paper style={{ margin: "1rem" }}>
        <TableContainer component={Paper} style={{ marginBottom: "20px" }}>
          <Table>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>{/* <Checkbox /> */}</StyledTableCell>
                <StyledTableCell align="left">
                  <TableSortLabel
                    active={this._orderBy === "name"}
                    direction={this._orderBy === "name" ? this._order : "asc"}
                    // onClick={() => this.handleRequestSort('email')}
                    style={{ minWidth: "120px" }}
                  >
                    Contact Name
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this._orderBy === "email"}
                    direction={this._orderBy === "email" ? this._order : "asc"}
                    // onClick={() => this.handleRequestSort('userType')}
                    style={{ minWidth: "120px" }}
                  >
                    Email
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this._orderBy === "phone"}
                    direction={this._orderBy === "phone" ? this._order : "asc"}
                    // onClick={() => this.handleRequestSort('userType')}
                    style={{ minWidth: "120px" }}
                  >
                    Phone Number
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <TableSortLabel
                    active={this._orderBy === "location"}
                    direction={
                      this._orderBy === "location" ? this._order : "asc"
                    }
                    // onClick={() => this.handleRequestSort('userType')}
                    style={{ minWidth: "120px" }}
                  >
                    Locations
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <TableSortLabel
                    active={this._orderBy === "createdAt"}
                    direction={
                      this._orderBy === "createdAt" ? this._order : "asc"
                    }
                    // onClick={() => this.handleRequestSort('createdAt')}
                    style={{ minWidth: "120px" }}
                  >
                    Created On
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {this._contacts?.length > 0 &&
                this._contacts
                  .slice(
                    (this.state.pageNum - 1) * rowsPerPage,
                    (this.state.pageNum - 1) * rowsPerPage + rowsPerPage
                  )
                  .map((contact, index) => (
                    <StyledTableRow key={`key-${contact.contactId}`}>
                      <TableCell align="left">
                        {/* <AccountBoxIcon /> */}
                        <Checkbox
                          checked={this.isContactChecked(contact.contactId)}
                          onChange={(event) =>
                            this.checkContactHandler(event, contact)
                          }
                          inputProps={{ "aria-label": "controlled" }}
                          style={{ color: "#6c757d" }}
                        />
                      </TableCell>
                      <TableCell>{contact.name}</TableCell>
                      <TableCell>{contact.email}</TableCell>
                      <TableCell>{contact.phone}</TableCell>
                      <TableCell>
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {contact.locations.map((loc: any) => (
                            <CustomLocation style={{ fontWeight: "500" }}>
                              {loc.locationName}
                            </CustomLocation>
                          ))}
                        </div>
                      </TableCell>
                      <TableCell align="center">
                        {new Date(contact.createdAt).toLocaleDateString()}
                      </TableCell>
                      <TableCell align="center">
                        <CustomIconButton
                          onClick={async () => {
                            this._selectedContactId = contact.contactId;
                            this._actionType = "Update";
                            this._showContactModal = true;
                            await this.getContactInfo(contact.contactId);
                          }}
                        >
                          <EditIcon />
                        </CustomIconButton>
                        {
                          // this._deletingUser?.uid == contact.uid
                          false ? (
                            <CircularProgress size={18} />
                          ) : (
                            <CustomIconButton
                              edge="end"
                              aria-label="delete"
                              // disabled={this._deletingUser != null}
                              onClick={() => {
                                this._selectedContactId = contact.contactId;
                                this._showContactModal = true;
                                this._actionType = "Delete";
                              }}
                            >
                              <DeleteIcon />
                            </CustomIconButton>
                          )
                        }
                      </TableCell>
                    </StyledTableRow>
                  ))}
            </TableBody>
          </Table>
          {this._contacts.length > 0 && (
            <Pagination
              count={Math.trunc(this._contacts.length / rowsPerPage + 1)}
              color="primary"
              style={{
                margin: "20px auto",
                width: "fit-content",
              }}
              onChange={this.pageChangeHandler}
            />
          )}
        </TableContainer>
      </Paper>
    );
  }

  @autobind
  renderContactModal(type: ActionType) {
    return (
      <Dialog
        open={this._showContactModal}
        style={{ width: "600px", margin: "0 auto" }}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>{`${type} Contact`}</span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                this._showContactModal = false;
              }}
            >
              <ClearIcon />
            </span>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: "0" }}>
          {this._actionType === "Delete" ? (
            <p
              style={{
                padding: "1rem 2rem",
                fontSize: "1.3rem",
                marginTop: "1.5rem",
              }}
            >
              Are you sure you want to delete the contact ?
            </p>
          ) : (
            <Form style={{ padding: "1.5rem 2rem", width: "500px" }}>
              <Form.Group>
                <Form.ControlLabel>Name</Form.ControlLabel>
                <Input
                  style={{ width: "100%" }}
                  placeholder="Name"
                  onChange={this.handleNameChange}
                  disabled={this._status == "LOADING"}
                  value={this._name}
                />
                {this._checkEmptyForm && !this._name && (
                  <CustomHelperTextError />
                )}
              </Form.Group>
              <Form.Group>
                <Form.ControlLabel>Email</Form.ControlLabel>
                <Input
                  style={{ width: "100%" }}
                  placeholder="Email"
                  onChange={this.handleEmailChange}
                  disabled={this._status == "LOADING"}
                  value={this._email}
                />
                {this._checkEmptyForm && !this._email && (
                  <CustomHelperTextError />
                )}
              </Form.Group>
              <Form.Group>
                <Form.ControlLabel>Phone</Form.ControlLabel>
                <PhoneInput
                  country={"us"}
                  value={this._phone}
                  disabled={this._status == "LOADING"}
                  onChange={this.handlePhoneChange}
                  inputClass="rs-input"
                  inputStyle={{ width: "100%" }}
                  dropdownStyle={{ zIndex: "10000000" }}
                />
                {this._checkEmptyForm && !this._phone && (
                  <CustomHelperTextError />
                )}
              </Form.Group>

              <Form.Group>
                <Form.ControlLabel>Locations</Form.ControlLabel>
                <TagPicker
                  data={this.listToDataPicker(
                    this._locations,
                    "locationId",
                    "locationName",
                    ""
                  )}
                  value={this._selectedLocations}
                  onChange={this.handleLocationsChange}
                  style={{ width: "100%", zIndex: "0" }}
                  menuStyle={{ zIndex: "100000" }}
                  onClean={() => (this._selectedLocations = [])}
                />
                {this._checkEmptyForm &&
                  this._selectedLocations?.length == 0 && (
                    <CustomHelperTextError />
                  )}
              </Form.Group>
            </Form>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: "1.5rem 1rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              this._showContactModal = false;
              setTimeout(() => {
                this.resetValues();
              });
            }}
            size="medium"
            style={{ height: "40px", margin: "0 1rem" }}
            disabled={this.isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={(event) => {
              this.isLoading = true;
              type === "Add" && this.addContactHandler(event);
              type === "Update" && this.updateContactHandler(event);
              type === "Delete" && this.deleteContactHandler(event);
            }}
            size="medium"
            style={{
              height: "40px",
              margin: "0 1rem",
              display: "flex",
              justifyContent: "center",
            }}
            disabled={this.isLoading}
          >
            {this.isLoading ? (
              <CircularProgress size={18} style={{ color: "inherit" }} />
            ) : (
              `${type} Contact`
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderSendModal() {
    const emailInputData = {
      fields: [
        {
          name: "Search Existing Contact(s)",
          Component: TagPicker,
          data: this.listToDataPicker(
            this._fsContacts,
            "contactId",
            "name",
            ""
          ),
          value: this._selectedContacts,
          onChange: (val: any) => (this._selectedContacts = val),
          props: {
            style: { width: "100%", zIndex: "0" },
            menuStyle: { zIndex: "100000" },
            onClean: () => (this._selectedContacts = []),
          },
        },
        {
          name: "Location",
          Component: SelectPicker,
          data: this.listToDataPicker(
            this._locations,
            "locationId",
            "locationName",
            "locationId"
          ),
          value: this.selectedLocation,
          onChange: (val: any) => this.handleLocationChange(val),
          props: {
            style: { width: "100%", zIndex: "0" },
            menuStyle: { zIndex: "100000" },
            searchable: false,
          },
        },
        {
          name: "Workflow",
          Component: SelectPicker,
          data: this.listToDataPicker(
            this._workflows,
            "workflowId",
            "workflowName",
            "workflowId"
          ),
          value: this.selectedWorkflow,
          onChange: (val: any) => (this.selectedWorkflow = val),
          props: {
            style: { width: "100%", zIndex: "0" },
            menuStyle: { zIndex: "100000" },
            searchable: false,
          },
        },
        {
          name: "Email Template",
          Component: SelectPicker,
          data: this.listToDataPicker(
            this._fsTemplates.filter(
              (temp) => temp.type === this.state.sendCategory
            ),
            "templateId",
            "name",
            "templateId"
          ),
          value: this.selectedTemplate,
          onChange: (val: any) => (this.selectedTemplate = val),
          props: {
            style: { width: "100%", zIndex: "0" },
            menuStyle: { zIndex: "100000" },
            searchable: false,
          },
        },
      ],
      checkEmptyForm: this._checkEmptyForm,
    };
    const smsInputData = {
      fields: [
        {
          name: "Search Existing Contact(s)",
          Component: TagPicker,
          data: this.listToDataPicker(
            this._fsContacts,
            "contactId",
            "name",
            ""
          ),
          value: this._selectedContacts,
          onChange: (val: any) => (this._selectedContacts = val),
          props: {
            style: { width: "100%", zIndex: "0" },
            menuStyle: { zIndex: "100000" },
            onClean: () => (this._selectedContacts = []),
          },
        },
        {
          name: "SMS Template",
          Component: SelectPicker,
          data: this.listToDataPicker(
            this._fsTemplates.filter(
              (temp) => temp.type === this.state.sendCategory
            ),
            "templateId",
            "name",
            "templateId"
          ),
          value: this.selectedTemplate,
          onChange: (val: any) => (this.selectedTemplate = val),
          props: {
            style: { width: "100%", zIndex: "0" },
            menuStyle: { zIndex: "100000" },
            searchable: false,
          },
          type: "ratioWrapper",
          ratioName: "smsTemplate",
          ratioTitle: "Choose Existing SMS Template",
          ratioVal: "exist",
          currentVal: this.state.ratioSMSTemplate,
          ratioHandler: (val) =>
            this.setState({ ...this.state, ratioSMSTemplate: val }),
        },
        {
          name: "SMS Message",
          Component: Input,
          value: this.smsText,
          onChange: (val: any) => (this.smsText = val),
          props: {
            as: "textarea",
            rows: 5,
            placeholder: "SMS Message",
            value: this.smsText,
            onChange: (val) => (this.smsText = val),
          },
          type: "ratioWrapper",
          ratioName: "smsTemplate",
          ratioTitle: "New SMS Message",
          ratioVal: "new",
          currentVal: this.state.ratioSMSTemplate,
          ratioHandler: (val) =>
            this.setState({ ...this.state, ratioSMSTemplate: val }),
        },
        {
          name: "Include Profil Picture",
          type: "checkboxWrapper",
          Component: CustomCheckBox,
          value: this.includeProfilImg,
          onChange: (_: any, checked: boolean) =>
            (this.includeProfilImg = checked),
        },
      ],
      checkEmptyForm: this._checkEmptyForm,
    };
    return (
      <Dialog
        open={this._showSendModal}
        style={{ width: "600px", margin: "0 auto" }}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Send</span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                this._showSendModal = false;
              }}
            >
              <ClearIcon />
            </span>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: "0" }}>
          <Form style={{ padding: "1.5rem 2rem", width: "500px" }}>
            <Form.Group>
              <RadioGroup
                inline
                name="sendCategorie"
                value={this.state.sendCategory}
                onChange={(value: string) => {
                  this.handleSendCategoryChange("sendCategory", value);
                  this.sendLater = false;
                  this.selectedTemplate = "";
                  this.selectedWorkflow = "";
                  this.selectedLocation = "";
                  this.sendAt = null;
                }}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Radio value="email">Email</Radio>
                <Radio value="sms">SMS</Radio>
              </RadioGroup>
            </Form.Group>
            {this.state.sendCategory === "SMS" &&
              CustomContactForm(smsInputData)}
            {this.state.sendCategory === "Email" &&
              CustomContactForm(emailInputData)}
            <Form.Group>
              <Form.ControlLabel>
                <CustomCheckBox
                  checked={this.sendLater}
                  onChange={(_: any, checked: boolean) =>
                    (this.sendLater = checked)
                  }
                >
                  Send Later
                </CustomCheckBox>
                <CustomTooltip
                  placement="bottom-start"
                  arrow
                  title={
                    <Box
                      style={{
                        zIndex: "100000",
                        textAlign: "start",
                        maxWidth: "none",
                        width: "320px",
                      }}
                    >
                      <Typography marginBottom="6px">
                        - Email schedule can be in 72 hours in advance.
                      </Typography>
                      <Typography>
                        - SMS schedule can be between 15 minutes and 7 days in
                        advance.
                      </Typography>
                    </Box>
                  }
                >
                  <HelpOutlineIcon style={{ marginLeft: "5px" }} />
                </CustomTooltip>
              </Form.ControlLabel>
              {this.sendLater && (
                <Form.Group>
                  <Form.ControlLabel>Select a date and time</Form.ControlLabel>
                  <DatePicker
                    format="MM-dd-yyyy HH:mm"
                    placement="topStart"
                    value={this.sendAt}
                    onChange={(val: any) => (this.sendAt = val)}
                    block
                    ranges={[
                      {
                        label: "Now",
                        value: new Date(),
                      },
                    ]}
                    onClean={() => (this.sendAt = null)}
                    hideSeconds={(second: number, date: Date) => false}
                    style={{ zIndex: "100000" }}
                  />
                </Form.Group>
              )}
            </Form.Group>
          </Form>
        </DialogContent>
        <DialogActions
          style={{
            padding: "1.5rem 1rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              this._showSendModal = false;
            }}
            size="medium"
            style={{ height: "40px", margin: "0 1rem" }}
            disabled={this.isLoading}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            size="medium"
            style={{
              height: "40px",
              margin: "0 1rem",
              display: "flex",
              justifyContent: "center",
            }}
            disabled={this.isLoading}
            onClick={(ev) => {
              this.isLoading = true;
              this.sendHandler(ev);
            }}
          >
            {this.isLoading ? (
              <CircularProgress size={18} style={{ color: "inherit" }} />
            ) : (
              "send"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderLocationsModal(type: string) {
    return (
      <Dialog
        open={this._showLocationsModal}
        style={{ width: "600px", margin: "0 auto" }}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>{`${this._locationActionType} Locations`}</span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                this._showLocationsModal = false;
              }}
            >
              <ClearIcon />
            </span>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: "0" }}>
          <Form style={{ padding: "1.5rem 2rem", width: "500px" }}>
            <Form.Group>
              <Form.Group>
                <Form.ControlLabel>
                  Search Existing Contact(s)
                </Form.ControlLabel>
                <TagPicker
                  data={this.listToDataPicker(
                    this._fsContacts,
                    "contactId",
                    "name",
                    ""
                  )}
                  value={this._selectedContacts}
                  onChange={(val: any) => (this._selectedContacts = val)}
                  style={{ width: "100%", zIndex: "0" }}
                  menuStyle={{ zIndex: "100000" }}
                  onClean={() => (this._selectedContacts = [])}
                />
                {this._checkEmptyForm && this.selectedLocation == "" && (
                  <CustomHelperTextError />
                )}
              </Form.Group>
              <Form.ControlLabel>Locations</Form.ControlLabel>
              <TagPicker
                data={this.listToDataPicker(
                  this._locations,
                  "locationId",
                  "locationName",
                  ""
                )}
                value={this.locationsToAction}
                onChange={(val: any) => (this.locationsToAction = val)}
                style={{ width: "100%", zIndex: "0" }}
                menuStyle={{ zIndex: "100000" }}
                searchable={false}
                onClean={() => (this.locationsToAction = [])}
              />
              {this._checkEmptyForm && this.locationsToAction?.length > 0 && (
                <CustomHelperTextError />
              )}
            </Form.Group>
          </Form>
        </DialogContent>
        <DialogActions
          style={{
            padding: "1.5rem 1rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              this._showLocationsModal = false;
              this.locationsToAction = [];
            }}
            size="medium"
            disabled={this.isLoading}
            style={{ height: "40px", margin: "0 1rem" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            style={{
              height: "40px",
              margin: "0 1rem",
              display: "flex",
              justifyContent: "center",
            }}
            disabled={this.isLoading}
            onClick={(ev: any) => {
              this.isLoading = true;
              type === "Add"
                ? this.addLocationsHandler(ev)
                : this.removeLocationsHandler(ev);
            }}
          >
            {this.isLoading ? (
              <CircularProgress size={18} style={{ color: "inherit" }} />
            ) : (
              "Save"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderSnackbar(status: string) {
    const { sendCategory } = this.state;
    let message = "";
    let messageType: SnackbarMessageType = "success";
    switch (status) {
      case "CONTACT_IS_EXIST":
        message = "Contact already exists";
        messageType = "error";
        break;
      case "ADD_SUCCESS":
        message = "Contact added successfully";
        break;
      case "UPDATE_SUCCESS":
        message = "Contact updated successfully";
        break;
      case "DELETE_SUCCESS":
        message = "Contact deleted successfully";
        break;
      case "EMPTY_SELECTED_CONTACTS":
        message = "No contact is selected";
        messageType = "error";
        break;
      case "ADD_LOCATIONS_SUCCESS":
        message = "Location(s) added successfully";
        break;
      case "REMOVE_LOCATIONS_SUCCESS":
        message = "Location(s) removed successfully";
        break;
      case "DELETE_CONTACTS_SUCCESS":
        message = "Contact(s) deleted successfully";
        break;
      case "SEND_EMAIL_SMS":
        message = `Survey sent via ${sendCategory}.`;
        break;
      case "EMPTY_SELECTED_TEMPLATE":
        message = "No template is selected";
        messageType = "error";
    }

    return (
      <Snackbar
        open={this._showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          this._showSnackbar = false;
          this._status = "NORMAL";
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div>{message && <Alert severity={messageType}>{message}</Alert>}</div>
      </Snackbar>
    );
  }

  renderDeleteModal() {
    return (
      <Dialog
        open={this._showDeleteModal}
        style={{ width: "600px", margin: "0 auto" }}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Delete Contact(s)</span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                this._showDeleteModal = false;
              }}
            >
              <ClearIcon />
            </span>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: "0" }}>
          <Form style={{ padding: "1.5rem 2rem", width: "500px" }}>
            <Form.Group>
              <Form.ControlLabel>Search Existing Contact(s)</Form.ControlLabel>
              <TagPicker
                data={this.listToDataPicker(
                  this._fsContacts,
                  "contactId",
                  "name",
                  ""
                )}
                value={this._selectedContacts}
                onChange={(val: any) => (this._selectedContacts = val)}
                style={{ width: "100%", zIndex: "0" }}
                menuStyle={{ zIndex: "100000" }}
                onClean={() => (this._selectedContacts = [])}
              />
              {this._checkEmptyForm && this.selectedLocation == "" && (
                <CustomHelperTextError />
              )}
            </Form.Group>
          </Form>
        </DialogContent>
        <DialogActions
          style={{
            padding: "1.5rem 1rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              this._showDeleteModal = false;
            }}
            size="medium"
            disabled={this.isLoading}
            style={{ height: "40px", margin: "0 1rem" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={(ev: any) => {
              this.isLoading = true;
              this.deleteContactsHandler(ev);
            }}
            size="medium"
            disabled={this.isLoading}
            style={{ height: "40px", margin: "0 1rem" }}
          >
            {this.isLoading ? (
              <CircularProgress size={18} style={{ color: "inherit" }} />
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Box width="100%" height="env(safe-area-inset-top)" bgcolor="#3f51b5" />
        {this.renderNavBar()}
        {this.renderSearchBar()}
        {this.dataLoading ? (
          <Box display="flex" flexDirection="column" alignItems="center">
            <CircularProgress size={36} style={{ marginTop: "4rem" }} />
          </Box>
        ) : (
          <React.Fragment>
            {this.renderGlobalAction()}
            {this.renderContactsTable()}
          </React.Fragment>
        )}
        {this.renderContactModal(this._actionType)}
        {this.renderSendModal()}
        {this.renderLocationsModal(this._locationActionType)}
        {this.renderDeleteModal()}
        {this.renderSnackbar(this._status)}
      </React.Fragment>
    );
  }
}
